module.exports = __webpack_public_path__ + "static/media/student-summary-win5.3f5b46b1.png";